var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('div',[_c('hr',{staticClass:"thin"}),_c('div',{staticClass:"form-group"},[_vm._v(" Email address: "),_c('a',{attrs:{"href":`mailto:${_vm.emailAddress}`}},[_c('img',{staticStyle:{"vertical-align":"bottom"},attrs:{"height":"24","src":_vm.emailAddressImage,"alt":"email address"}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }